/**
 * Detect mobile OS from user agent. Used for "Open in app" and app store banners.
 */
export function getMobileOS(): 'ios' | 'android' | null {
  if (typeof navigator === 'undefined') return null;
  const ua = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/.test(ua)) return 'ios';
  if (/android/i.test(ua)) return 'android';
  console.log('agent', ua);
  return null;
}
